import Axios from 'axios'
import Config from '../config/app.js'
import {
    Notification,
    Message,
    Loading
} from 'element-ui';
import {
    getToken,
    removeToken,
    removeUserInfo
} from '../utils/dataStorage.js'

const service = Axios.create({
    baseURL: Config.apiUrl + '/' + Config.apiPrefix,
    headers: {
        'Accept': 'application/json',
        appId:'wxed0090b6e7f0e56c',
    },
    timeout: Config.timeout,
    closeLoading: true
})
service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
    config => {
        if (!config.closeLoading) {
            window.loadingInstance = Loading.service();
        }

        let noParameters = config.url.indexOf('?') == -1;
        var token = getToken();
        //config.url = noParameters ? config.url + '?access_token=' + getToken() : config.url + '&access_token=' + getToken();
        config.headers[Config.tokenKey] = escape(getToken());
        return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        if (!response.config.closeLoading) {
            setTimeout(_ => {
                window.loadingInstance.close();
            }, 400);
        }
        const res = response
        if (res.status !== 200) {
            Notification({
                title: '温馨提示',
                message: "服务器可能遇到问题，请稍后重试",
                type: 'warning'
            });
        } else {
            if ((response.config).hasOwnProperty('closeInterceptors') && response.config.closeInterceptors) {
                return res.data
            }
            if (res.data.code != 0) {
                if (res.data.code == 2) {
                    Message({
                        message: res.data.msg,
                        type: 'warning'
                    });
                } else if (res.data.code == 8) { // 登录状态失效
                    sessionStorage.removeItem(Config.tokenKey);
                    // 关闭socket
                    // this.$socketApi.socket_close();
                    window.location.href = "#/login"
                } else if (res.data.code == 6) { // 接口权限不足
                    Message({
                        message: res.data.msg,
                        type: 'warning'
                    });
                } else {
                    Message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
                return Promise.reject('error');
            }
            return res.data.data
        }
    },
    error => {
        console.error(error)
        setTimeout(_ => {
            window.loadingInstance.close();
        }, 300)
        Notification({
            title: "提示",
            message: "服务器可能遇到问题，请稍后重试",
            type: 'warning'
        });
        return Promise.reject(error)
    }
)

export default service